/**
 * 费用分摊编辑器
 *
 */

'use strict'

import Vue from 'vue';
import Component from "vue-class-component";
import { iStorage, iValidator } from 'smart-core-util';
import { costValidator } from '@scripts/validators/costValidator.js';
@Component
class costEditor extends Vue {

    validator = costValidator;

    costForm = {
        costCenter: "", //成本中心
        costCenterChildItem: [], // 成本中心下的wbs
        wbs: "", //
        rate: 100, //分摊预算百分比
        partnerName: "", //财务部业务伙伴
        partnerEmail: "", //电子邮件地址
        legalEntity: "" //法律实体
    }
    get proposalId() {
        return iStorage.get("proposalId");
    }

    async saveAsync({ onSuccess, toast, $messageError, type }) {
    	let _costCenter = this.costForm.costCenter.substring(0,5)
        let costCenterChildItem = this.costForm.costCenterChildItem || []
    	this.validator.wbs.required = costCenterChildItem.length > 0 ? true : false;
    	let regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!new iValidator().validate({
            model: this.costForm,
            validator: this.validator,
            toast: toast
        }))
            return;
        //邮箱不必填,但是有值需验证格式
        if(this.costForm.partnerEmail && !regEmail.test(this.costForm.partnerEmail)){
            toast && toast("邮箱格式不正确");
            $messageError && $messageError("邮箱格式不正确");
        	return
        }
        //邮箱不必填,但是有值需验证格式
        if(this.costForm.rate  > 100){
            toast && toast("分摊预算百分比不能超过100");
            $messageError && $messageError("分摊预算百分比不能超过100");
            return
        }
        var params = {
            miceId: this.proposalId, // this.storage.get("proposalId"), //会议id
            costCenter: this.costForm.costCenter, //成本中心
            wbs: this.costForm.wbs, //wbs code
            rate: this.costForm.rate, //百分比
            partnerName: this.costForm.partnerName, //分摊人
            partnerEmail: this.costForm.partnerEmail, //分摊人邮箱
            employeeId: this.costForm.employeeId,//员工id
            legalEntity: this.costForm.legalEntity,//法律实体
        };
        //编辑
        if (this.isEdit) {
            params.allocationId = (type && type == 'web') ? this.costForm.allocationId : this.$route.query.item.allocationId;
        }
        var result = await this.api.post(this.url.expenseAllocation.save, params);
        {
            if (result && result.success) {
                onSuccess(result);
            }
        };
    }
}

export default costEditor;



// WEBPACK FOOTER //
// ../scripts/components/costEditor.js